import { useState } from 'react';

export type UseDisclosureActions = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

type UseDisclosureReturn = [boolean, UseDisclosureActions];

type UseDisclosureHandlers = {
  onOpen?: () => void;
  onClose?: () => void;
};

const useDisclosure = (
  InitialValue = false,
  handlers?: UseDisclosureHandlers,
): UseDisclosureReturn => {
  const [isOpened, setIsOpened] = useState(InitialValue);

  function handleOpen() {
    setIsOpened(true);
    if (handlers?.onOpen) {
      handlers?.onOpen();
    }
  }

  function handleClose() {
    setIsOpened(false);
    if (handlers?.onClose) {
      handlers?.onClose();
    }
  }

  function handleToggle() {
    setIsOpened(!isOpened);

    if (!isOpened) {
      if (handlers?.onOpen) {
        handlers?.onOpen();
      }
    } else {
      if (handlers?.onClose) {
        handlers?.onClose();
      }
    }
  }

  return [
    isOpened,
    { open: handleOpen, close: handleClose, toggle: handleToggle },
  ];
};

export default useDisclosure;
